import {Component, OnInit} from '@angular/core';
import {ListingService} from '../../../services/listing/listing.service';

import {ToastyService} from 'ng2-toasty';
import {Notification} from '../../../shared/api-error';
import {PAGE_SIZES} from '../../../../utils';
import {Router} from '@angular/router';
import * as moment from 'moment';

declare const $: any;
declare var Morris: any;

@Component({
  selector: 'app-user-listing',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  public readonly position = 'top-center';
  public usersList = [];
  public userListMsg = 'Loading...';
  public pageNo = 1;
  public pageSize = 15;
  public total = 0;
  public userInitialLoad = true;
  public loading = false;
  public moment = moment;
  public role = '';
  public searchValue = '';

  constructor(
    private listingService: ListingService,
    private router: Router,
    private toastyService: ToastyService
  ) {
  }

  getUsers() {
    this.loading = true;
    this.listingService
      .getUsers(this.pageNo, this.pageSize, this.role, this.searchValue)
      .subscribe(
        res => {
          this.loading = false;
          const {users = [], total} = res;
          this.total = total;
          this.usersList = users;
          this.userListMsg = 'No Users Found !!!';
        },
        err => {
          this.loading = false;
          const {message} = err;
          const option = {
            title: 'Error in Fetching Users List',
            msg: message,
            timeout: 1500
          };
          this.userListMsg = 'Error in Loading User List';
          this.toastyService.clearAll();
          this.toastyService.error(Notification.getNotification(option));
        }
      );
  }

  ngOnInit() {
    this.getUsers();
  }

  getRole(role) {
    switch (role) {
      case 'provider':
        return 'Provider';
      case 'organization':
        return 'Organization User';
      case 'admin':
        return 'Eddy Admin';
      case 'providerAgent':
        return 'Provider Agent';
    }
  }

  pageChange({currentPage, pageSize}) {
    if (this.userInitialLoad) {
      this.userInitialLoad = false;
      return;
    }
    this.pageNo = currentPage;
    this.pageNo = this.pageSize === pageSize ? currentPage : 1;
    this.pageSize = pageSize;
    this.getUsers();
  }

  getPageSizes() {
    return PAGE_SIZES;
  }

  goToUser(id) {
    this.router.navigate([`/user/${id}`]);
  }

  addUser() {
    this.router.navigate(['/user/add']);
  }

  deleteUser(id) {
    this.loading = true;
    this.listingService.deleteUser(id).subscribe(
      res => {
        this.loading = false;
        const option = {
          title: 'Success User Deletion',
          msg: 'User Deleted Successfully',
          timeout: 1500
        };
        this.toastyService.clearAll();
        this.toastyService.success(Notification.getNotification(option));
        this.getUsers();
      },
      err => {
        this.loading = false;
        const {message} = err;
        const option = {
          title: 'Error in Deleting User',
          msg: message,
          timeout: 2000
        };
        this.toastyService.clearAll();
        this.toastyService.error(Notification.getNotification(option));
      }
    );
  }

  search(searchValue) {
    this.searchValue = searchValue;
    this.usersList = [];
    this.pageNo = 1;
    this.getUsers();
  }

  changeRole({target: {value = ''} = {}}) {
    this.pageNo = 1;
    this.role = value;
    this.getUsers();
  }
}



// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/listing/user/user.component.ts